import { Navigate, createBrowserRouter } from "react-router-dom";

import { AdminRoute } from "@/auth/AdminRoute";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { App } from "@/App";
import { DashboardPage } from "./pages/DashboardPage";
import { CategoriesPage } from "@/pages/CategoriesPage";
import { FiltersPage } from "@/pages/FiltersPage";
import { EventDetailPage } from "@/pages/EventDetailPage";
import { EventsPage } from "@/pages/EventsPage";
import { LoginPage } from "@/pages/LoginPage";
import { MailboxesPage } from "@/pages/admin/MailboxesPage";
import { UsersPage } from "@/pages/admin/UsersPage";
import { MonitoringPage } from "@/pages/admin/MonitoringPage";
import { ReviewPage } from "@/pages/ReviewPage";
import { PriorityReviewPage } from "@/pages/PriorityReviewPage";
import { CalendarPage } from "@/pages/CalendarPage";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <App />,
        children: [
          {
            index: true,
            element: <Navigate to="/dashboard" replace />,
          },
          {
            path: "dashboard",
            element: <DashboardPage />,
          },
          {
            path: "events",
            element: <EventsPage />,
          },
          {
            path: "events/:id",
            element: <EventDetailPage />,
          },
          {
            path: "review",
            element: <ReviewPage />,
          },
          {
            path: "priority-review",
            element: <PriorityReviewPage />,
          },
          {
            path: "calendar",
            element: <CalendarPage />,
          },
          {
            path: "categories",
            element: <CategoriesPage />,
          },
          {
            path: "filters",
            element: <FiltersPage />,
          },
          {
            element: <AdminRoute />,
            children: [
              {
                path: "admin/users",
                element: <UsersPage />,
              },
              {
                path: "admin/mailboxes",
                element: <MailboxesPage />,
              },
              {
                path: "admin/monitoring",
                element: <MonitoringPage />,
              },
            ],
          },
        ],
      },
    ],
  },
]);
